import React from 'react';
import { LAW_CONFIG } from '../../data/laws';

export default function GameModeSelect({ selectedLaw, selectedStage, gameModeType, setView, setMode, setGameState, setSelectedStage }) {
  const config = LAW_CONFIG[selectedLaw];
  
  const safeStageId = (selectedStage && typeof selectedStage === 'object') 
    ? selectedStage.id 
    : selectedStage;

  const isLastStage = config && safeStageId === config.maxStage;

  return (
    <div className="flex flex-col items-center justify-center space-y-6 py-10 relative">
      <div className="absolute inset-0 border-[6px] border-double border-amber-600/30 rounded-xl pointer-events-none"></div>
      
      <h2 className="text-2xl font-bold text-white z-10">학습 모드 선택</h2>
      
      {safeStageId && (
        <span className="text-indigo-300 font-bold bg-indigo-900/50 px-3 py-1 rounded-full z-10 border border-indigo-500/30">
          {isLastStage ? '전체 조문 연습' : `${safeStageId}단계 학습`}
        </span>
      )}

      <div className="flex flex-col space-y-4 w-full max-w-md z-10">
        <button 
          onClick={() => { 
            if (setSelectedStage) setSelectedStage(safeStageId);
            setMode('beginner'); 
            setGameState('playing'); 
            if (setView) setView('game');
          }} 
          className="w-full p-6 bg-slate-800/80 border-2 border-green-500 rounded-xl shadow-lg transition-all hover:scale-[1.02] text-left"
        >
          <span className="text-white text-lg font-bold border-l-4 border-green-500 pl-2 mb-2 block">초보자 모드</span>
          <p className="text-slate-200 font-bold pl-3 text-sm">2지 선다형. 빠르고 가볍게 회독하기 좋습니다.</p>
        </button>

        <button 
          onClick={() => { 
            if (setSelectedStage) setSelectedStage(safeStageId);
            setMode('expert'); 
            setGameState('playing'); 
            if (setView) setView('game');
          }} 
          className="w-full p-6 bg-slate-800/80 border-2 border-red-500 rounded-xl shadow-lg transition-all hover:scale-[1.02] text-left"
        >
          <span className="text-white text-lg font-bold border-l-4 border-red-500 pl-2 mb-2 block">숙련자 모드</span>
          <p className="text-slate-200 font-bold pl-3 text-sm">입력 → 초성 → 선택지 3단계. 완벽 암기용.</p>
        </button>

        {/* [수정] 안전한 돌아가기 */}
        <button 
          onClick={() => { 
            if (gameModeType === 'challenge') {
                setView('home');
                return;
            }
            if (gameModeType === 'odaptong_retry') {
                setView('odaptong'); 
                return;
            }
            
            // 객체 상태라면 숫자로 변경 후 이동
            if (safeStageId && setSelectedStage) { 
                setSelectedStage(safeStageId);
                setView('stage_select'); 
            } else {
                setView('home'); 
            }
          }} 
          className="text-slate-500 hover:text-slate-300 underline z-10 mt-4 text-center w-full"
        >
          돌아가기
        </button>
      </div>
    </div>
  );
}